import React from 'react';
import Header from '../Header/header';
import Footer from '../../containers/Footer/footer';
import checkExistingUser from '../../services/checkExistingUser';
import addUser from '../../services/addUser';
import cookie from '../../cookieHelper/cookie';
import './User.scss';
import { Navigate } from 'react-router-dom';
// import '../AdminUserScreen/AdminUserScreen.scss';
import PopulateCompanyList from '../CompanyList/companyList';
import getCompanies from '../../services/getCompanyList';
import withRouter from '../withRouter';
import { auth as AuthObject } from '../../services/login'




class User extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            tokencheck:true,
            // userID: '',
            // status: '',
            // companyName: '',
            // role: '',
            // name: '',
            // email: '',
            // password: '',
            // companyName: '',
            tableState: 0,
            redirectToUserListing: false,
            companies : []


        }

        this.role = {
            1: "Normal User",
            2: "Admin"
        }
    }

    validate = () => {
        var e = document.getElementById("emailText").value;
        var atposition = e.indexOf("@");
        var dotposition = e.lastIndexOf(".");


        if (e.length == "") {
            document.getElementById("ema").innerHTML = "Please fill the email field";

            return false;
        }
        else if (atposition < 1 || dotposition < atposition + 2 || dotposition + 2 >= e.length) {

            document.getElementById("ema").innerHTML = "Incorrect Email";
            return false;
        }
        else {
            // this.checkUser();
            document.getElementById("ema").innerHTML = "";
            return true;
        }
    }
    is_validate = () => {
        // e.persist();
        var n = document.getElementById("is_name").value;
        var e = document.getElementById("is_emai").value;
        var p = document.getElementById("is_pswd").value;
        var atposition = e.indexOf("@");
        var dotposition = e.lastIndexOf(".");


        if (n.length == "") {
            document.getElementById("is_nam").innerHTML = "Name field cannot be empty";
            return false;
        }
        else if (e.length == "") {
            document.getElementById("is_ema").innerHTML = "Please fill the email field";

            return false;
        }
        else if (atposition < 1 || dotposition < atposition + 2 || dotposition + 2 >= e.length) {

            document.getElementById("is_ema").innerHTML = "Incorrect Email";
            return false;
        }
        // else if (p.length == "") {
        //     document.getElementById("is_pas").innerHTML = "Please fill the password field";

        //     return false;
        // }
        // else if (p.length < 4) {
        //     document.getElementById("is_pas").innerHTML = "Minimum 8 characters";
        //     return false;
        // }
        else {
            // this.inviteUser(e);
            // document.getElementById("is_finalMessage").innerHtml = "Successfully Logged in";
            document.getElementById("is_nam").innerHTML = "";
            document.getElementById("is_ema").innerHTML = "";
            return true;
        }
    }
    // tableStateCheck = () => {

    //     this.setState({
    //         tableState: 1
    //     })
    // }
    componentDidMount() {
        // this.loginProfileInfo = JSON.parse(localStorage.getItem('loginProfileInfo'));
        // this.createdBy = this.loginProfileInfo.id;
        // document.getElementById("btnSubmit").disabled = false ;
        var elem = document.getElementById("is");
        elem.classList.add("active");

        this.loginProfileInfo = JSON.parse(cookie.getCookie('loginProfileInfo'));
        this.createdBy = this.loginProfileInfo.id;

        //console.log("CREATED BY IS: ", this.loginProfileInfo.id);

        var elem = document.getElementById("is");
        elem.classList.add("active");

        // this.createdBy = '5c9b15d0f6f4892d78599385';
        let list = {};

        const companyList = async () => {
            let companiesResult = await getCompanies();

            if (!(companiesResult instanceof Error)) {
                if (companiesResult.status.code == "10200"){
                    list = companiesResult.data[0];

                    console.log("companyList: ", list);
                    this.getList = list;
                    // console.log(list.companies.length);
                    // let companyListing = <option>No company Found</option>;
                    // var companyListing = document.createElement('select');
                    if (typeof list === 'undefined') {
                        // console.log("if ran");
                        toastNotify(3, "No companies were found.");
                        this.setState({ companies: [{ value: '', display: 'No Companies Found' }] });
                    }
                    else if (Object.keys(list).length === 0) {
                        // console.log("else if-1 ran");
                        toastNotify(3, "No companies were found.");
                        this.setState({ companies: [{ value: '', display: 'No Companies Found' }] });
                    }
                    else if (list.companies.length) {
                        // console.log("else if-2 ran");
                        let teamsFromApi = list.companies.map(item => { return { value: item.id, display: item.companyName } })
                        this.setState({ companies: [{ value: '', display: 'Select Company' }].concat(teamsFromApi) });
                    }
                    else {
                        // console.log("else ran");
                        toastNotify(3, "No companies were found.");
                        this.setState({ companies: [{ value: '', display: 'No Companies Found' }] });
                    }
                }else{
                    toastNotify("3", "Some error occured while fetching companies list")
                }
            }else{
                const response = JSON.parse(companiesResult.request.response);
                const code = response?.status?.code;
                if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                    this.setState({ tokencheck: false });
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                }
                else{
                    toastNotify("3", "Some error occured while fetching companies list")

                }            }
        }
        
        companyList();
    }
    setCompanyID = (e) => {
        console.log("comapnyytID: ", e.target);

        this.setState({
            companyID: e.target.value
        })
    }
    inviteUser = async (e) => {

        // //console.log(e);

        e.preventDefault();
        const data = {
            name: document.getElementById("is_name").value,
            email: document.getElementById("is_emai").value,
            companyId: document.getElementById("is_select").value,
            invitedBy: this.createdBy,
            organisationName: document.getElementById("is_org").value,
            password: document.getElementById("is_pswd").value,
            status: document.getElementById("inviteTypeSelect").value
        }
        var ans = this.is_validate();

        if (ans == true) {
            try {
                //console.log("DATA: ", data);

                var value = await addUser(data);
                //console.log("value: ", value);
                var finalLoginMessage = document.getElementById('is_finalMessage');
                finalLoginMessage.innerHTML = "Successfully added new user";

                if(value.data.status.code == 10200){
                    var finalLoginMessage = document.getElementById('is_finalMessage');
                    finalLoginMessage.innerHTML = "Successfully added new user"; 
                }
                else{


                    var finalLoginMessage = document.getElementById('is_finalMessage');
                    finalLoginMessage.innerHTML = "Couldn't add new user. Please try again later.";   
                }
            }
            catch (err) {

                const response = JSON.parse(value.request.response);
                const code = response?.status?.code;


                if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                    this.setState({ tokencheck: false });
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                }




                var finalLoginMessage = document.getElementById('is_finalMessage');
                finalLoginMessage.innerHTML = "Couldn't add new user. Please try again later.";
            }
        }
        else {
            //console.log('Not Valid');

        }


    }
    // For Email API Check 
    checkUser = async () => {
        const data = document.getElementById("emailText").value;

        // //console.log("Data:",data);
        // document.getElementById("btnSubmit").disabled = true ;
        var ans = this.validate();
        
        if (ans == true) {
            let values = await checkExistingUser(data);
            
            // const code = values.response?.data?.status?.code ?? null;

            if(values && values["status"] == 200)
            {
                let rows = values.data.data[0].users[0];

            //console.log("values:", values);
            if (rows == null) {
                document.getElementById('finalMessage').innerHTML ="Not a registered User";
                this.setState({
                    tableState: 2
                })

            }
            else {
                // let rows = values.data.data[0].users[0];
                //console.log("rows", rows);
                this.setState({
                    userData: values,
                    rows: rows,
                    tableState: 1
                })

            }

            }
            else{

                const response = JSON.parse(values.request.response);
                const code = response?.status?.code;
                if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                    this.setState({ tokencheck: false });
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                }

            }  




            

        }
        else {
            //console.log("Enter an email id");
        }



    }
    setOrganisationName = (e) => {
        //console.log("In set organisation");
        // //console.log(e.target.name)
        let selectTag = e.target;
        let selectedOrganizationName = selectTag.options[selectTag.selectedIndex].text;
        document.getElementById("is_org").value = selectedOrganizationName;
    }
    // setEmailID = (e) => {}
    redirectHandler = () => {
        this.setState({
            redirectToUserListing: true
        })
    }

    render() {

        if (!this.state.tokencheck) {
            return <Navigate to={'/'} />
        }

        if (this.state.redirectToUserListing) {
            return <Navigate to={'/userListing'} />
        }

        let rows;
        // let activate;
        // let deactivate;
        // let assignedClass = [];
        // if (this.state.tableState == 1) {
        //     // activate = "activate hidden";
        //     // deactivate = "deactivate";
        //     assignedClass.push('activate');
        // }
        // else if (this.state.tableState == 2) {
        //     // activate = "activate";
        //     // deactivate = "deactivate hidden";
        //     assignedClass.push('deactivate');
        // }
        // //console.log(assignedClass);
        if (this.state.userData) {
            rows = (

                <tr >
                    <td>
                        <div className="checkboxes">
                            <p>{this.state.rows.name}</p>

                        </div>
                    </td>
                    <td>
                        <div className="checkboxes">
                            <p>{this.state.rows.email}</p>

                        </div>
                    </td>
                    <td>
                        <div className="checkboxes">
                            <p>{this.state.rows.userId}</p>

                        </div>
                    </td>
                    <td>
                        <div className="checkboxes">
                            <p>{this.state.rows.status}</p>

                        </div>
                    </td>
                    <td>
                        <div className="checkboxes">
                            <p>{this.state.rows.organisationName}</p>

                        </div>
                    </td>
                    <td>
                        <div className="checkboxes">
                            <p>{this.role[this.state.rows.role]}</p>

                        </div>
                    </td>

                    {/* <td>
                        <button className={assignedClass} onClick={this.onSubmit}>Delete</button>
                    </td> */}
                </tr>

            )

        }




        return (
            <div>
                <Header />

                <div className="bodyWrapper">
                    <section className="adminUserScreen_header">
                        <div className="wrapperAU">
                            <button className="wrapperButton" onClick={this.redirectHandler}>User Listing </button>
                            <h1>Check User</h1>

                            <div className="box-design">
                                <div className="form-group">
                                    <label>Email ID:</label>
                                    <input type="email" id="emailText" className="form_input" placeholder="Enter Email" />
                                    <div id="ema"></div>
                                </div>
                                <button type="submit" id="btnSubmit" className="btn-default"
                                    // onClick={this.validate}
                                    onClick={this.checkUser}
                                >
                                    Check User</button>
                                <div id="finalMessage"></div>
                            </div>
                        </div>
                    </section>

                    {
                        this.state.tableState === 1 ?
                            <div className="user_header">
                                <div className="wrapperTable">
                                    <table border="1" className="mtb20 recruiter_listing" width="100%">
                                        <tbody>
                                            <tr className="table-header">
                                                <th className="table_header">Name</th>
                                                <th className="table_header">Email</th>
                                                {/* <th className="table_header">Expiry</th> */}
                                                <th className="table_header">User ID</th>
                                                <th className="table_header ">Status</th>
                                                <th className="table_header ">Company</th>
                                                <th className="table_header ">Role</th>
                                                {/* <th className="table_header ">Action</th> */}
                                            </tr>
                                            {rows}
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                            : null

                    }
                    {
                        this.state.tableState === 2 ?
                            <div>

                                <section className="inviteScreen_header">
                                    {/* <h1 id="notRegistered"> Not a registered User </h1> */}
                                    <div className="wrapper">
                                        <h1>Add User</h1>

                                        <div className="box-design">
                                            <div className="form-group spacing">
                                                <label>Name:</label>
                                                <input type="text" id="is_name" className="form_input ele_spacing1 " placeholder="Enter Name"
                                                    value={this.state.name} onChange={e => this.setState({ name: e.target.value })}
                                                />
                                                <div id="is_nam"></div>
                                            </div>
                                            <div className="form-group spacing">
                                                <label>Email:</label>
                                                <input type="email" id="is_emai" className="form_input ele_spacing1 " placeholder="Enter email"
                                                    value={this.state.email} onChange={e => this.setState({ email: e.target.value })}

                                                />
                                                <div id="is_ema"></div>
                                            </div>
                                            <div className="form-group spacing">
                                                <label>Company List:</label>
                                                <select id="is_select" onChange={(e)=>this.setOrganisationName(e)}>
                                                        {this.state.companies.map((item) => <option key={item.value} value={item.value}>{item.display}</option>)}
                                                </select>
                                            </div>
                                            <div className="form-group spacing">
                                                <label>Invite User:</label>
                                                <select id="inviteTypeSelect" onChange={e => this.setState({ status: e.target.value })} name="inviteUSer" className="ele_spacing2"><option value="">Select Invite Option</option>
                                                    <option value="0" name="Send Email">Send Email</option>
                                                    <option value="1" name="Direct Invite">Direct Invite</option>
                                                </select>
                                            </div>
                                            <div className="form-group hidden">
                                                <label>Organisation:</label>
                                                <input type="text" id="is_org" className="form_input ele_spacing3" placeholder="Enter Organisation"

                                                />
                                                <div id="is_orgt"></div>
                                            </div>

                                            <div className="form-group spacing">
                                                <label>Password:</label>
                                                <input type="password" id="is_pswd" className="form_input ele_spacing3" placeholder="Enter Password"

                                                />
                                                <div id="is_pas"></div>
                                            </div>

                                            <div className="form-group spacing">
                                                <button type="submit" id="is_btnSubmit" className="btn-default" onClick={(e) => this.inviteUser(e)}>Invite</button>
                                                <div id="is_finalMessage"></div>
                                            </div>
                                        </div>
                                    </div>


                                </section>
                            </div> : null
                    }

                </div>





                <Footer />
            </div>
        )
    }


}

export default withRouter(User);